import React from 'react';
import {Card} from "primereact/card";

const ErrorPresentor = ({error}:any) => {
    return (
            <Card>
                <div style={{height:'50vh'}} className='flex justify-content-center align-items-center'>
                    <div className="text-center">
                        <h4>No Data Found</h4>
                        <p>{error.message}</p>
                    </div>
                </div>
            </Card>
    );
};

export default ErrorPresentor;